import { FC } from 'react';
import cx from 'classnames';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { Conditional } from '../../common';
import { HeaderStoreProps } from './types';
import { CatIconLocationFilled } from '@blocks-react/components/Icons/LocationFilled';
import { HeaderNavItem } from '../header-nav-item/HeaderNavItem';
import styles from './HeaderStore.module.scss';
import { MAIN_NAV_TRACK } from '../../../constants/analyticsConstants';

export const HeaderStore: FC<HeaderStoreProps> = ({
  action,
  handleDrawerProps,
  id,
  isMobile,
  isCurrent,
  label,
  subLabel,
  ariaLabel,
  isMobileSearch,
  isTooltipActive = false,
  storeLocatorMessage = '',
  handleToolTip
}) => {
  const mobileSearchClassnames = {
    'cat-u-theme-typography-label': isMobileSearch,
    'cat-u-theme-typography-label-sm': !isMobileSearch
  };

  return (
    <HeaderNavItem
      id={id}
      isCurrent={isCurrent}
      {...handleDrawerProps}
      onClick={action}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={MAIN_NAV_TRACK.STORE_INFORMATION_DRAWER_TEXT}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_MENU_CONTEXT}
      className={cx({
        [`${(styles['store_navigation'], 'col-6')}`]: isMobileSearch
      })}
      role="menu"
    >
      <CatIconLocationFilled
        className={cx({
          [`${styles['equipment_search']}`]: isMobileSearch
        })}
      />
      <div
        className={cx(
          {
            [`${styles['equipment_search']}`]: isMobileSearch
          },
          styles['header__store']
        )}
        aria-label={ariaLabel}
        data-testid="cat-header-store-icon"
      >
        <p className={cx('m-0 text-truncate', mobileSearchClassnames)}>
          {label}
        </p>
        <Conditional test={!!subLabel}>
          <p
            className={cx('m-0 text-truncate cat-u-theme-typography-footnote')}
          >
            {subLabel}
          </p>
        </Conditional>
        <Conditional test={isTooltipActive}>
          <CatTooltip
            className={styles['tooltip_wrapper']}
            position="bottom"
            isActive={isTooltipActive}
            data-testid="store-locator-message"
            onBlTooltipClose={() => {
              !!handleToolTip && handleToolTip();
            }}
          >
            <div
              slot="trigger"
              className={styles['tooltip_inline_width']}
            ></div>
            <div className={styles['tooltip-msg']}>{storeLocatorMessage}</div>
          </CatTooltip>
        </Conditional>
      </div>

      <Conditional test={!!isMobile && !isMobileSearch}>
        <CatIconChevronRight className={styles['chevron-icon']} />
      </Conditional>
    </HeaderNavItem>
  );
};
